// api-config.js
const isProduction = process.env.NODE_ENV === 'production';

// Protocols
const protocol_http = process.env.REACT_APP_HTTP || 'http';
const protocol_https = process.env.REACT_APP_HTTPS || 'https';
const protocol_ws = process.env.REACT_APP_WS || 'ws';
const protocol_wss = process.env.REACT_APP_WSS || 'wss';
const localhost = process.env.REACT_APP_LOCALHOST || 'localhost';

// Domains & Ports
const domain = process.env.REACT_APP_DOMAIN;
const port_0 = process.env.REACT_APP_PORT_0;
const port_1 = process.env.REACT_APP_PORT_1;

// API Key
const api_key = process.env.REACT_APP_API_KEY;

// Base URLs
const base_http = `${protocol_http}://${localhost}:${port_1}`;
const base_https = `${protocol_https}://${domain}`;
const base_http_2 = `${protocol_http}://${localhost}:${port_0}`;
const base_ws = `${protocol_ws}://${localhost}:${port_1}`;
const base_wss = `${protocol_wss}://${domain}/ws`;

// Select base URL based on environment
const api_base_url = isProduction ? base_https : base_http;
const api_base_url_2 = isProduction ? base_https : base_http_2;
const socket_base_url = isProduction ? base_wss : base_ws;

// Validate
if (!api_base_url) {
  throw new Error('API base URL is not defined. Check your .env file.');
}

// Export config
const apiConfig = {
  api_base_url,
  api_base_url_2,
  socket_base_url,
  api_key
};

export default apiConfig;
